<template>
  <div v-if="shopDistributions && formater">
    <v-sheet class="hidden-print" style="margin-top: 80px" />
    <MutiplePiecesPrint
      :showSinglePrint="true"
      :formater="formater"
      :datas="shopDistributions"
    />
  </div>
</template>
<script>
import PrintTemplates from "@/api/print_templates";
import MutiplePiecesPrint from "@/components/plugins/print/MutiplePiecesPrint";
import Distributions from "@/api/distributions";

export default {
  components: {
    MutiplePiecesPrint,
  },

  data: () => ({
    formater: null,
    shopDistributions: [],
  }),

  mounted() {
    PrintTemplates.fetchOne("shopMergeDistribution").then(
      function (response) {
        if (response.data.status.isOK()) {
          var formater = response.data.print_template.template;
          this.formater = formater;
          //获取单据详情
          Distributions.shopDistributionsPrint(this.$route.query).then(
            function (response) {
              if (response.data.status.isOK()) {
                var shopDistributions = [];
                response.data.shop_distributions.forEach(
                  (shop_distribution) => {
                    shop_distribution.shop = this.$printUtils.addCitiesName(
                      shop_distribution.shop
                    );
                    shopDistributions.push(
                      Object.assign({}, shop_distribution, {
                        print_date: new Date().toISOString().substr(0, 10),
                      })
                    );
                  }
                );
                this.shopDistributions = shopDistributions;
              }
            }.bind(this)
          );
        }
      }.bind(this)
    );
  },
};
</script>